<script setup>
const route = useRoute();
const { $get } = useAxios();

const perPage = reactive(36);

const page = computed({
  get() {
    return parseInt(route.query.page ?? "1");
  },
  async set(value) {
    await navigateTo(`/gift-ideas?page=${value}&mode=${mode.value}`);
    scrollToTop();
  },
});

const mode = computed({
  get() {
    return route.query?.mode ?? "tile";
  },
  async set(value) {
    await navigateTo(`/gift-ideas?page=${page.value}&mode=${value}`);
  },
});

const { data: totalProducts, pending: isTotalLoading } = useAsyncData(
  "get count gift products",
  () =>
    $get(
      `/api/v1/product/get/count?filter=isPublished||$eq||true;isGift||$eq||true`
    ),
  { default: () => 0, lazy: true }
);

const {
  data: products,
  pending: isProductsLoading,
  refresh: refreshProducts,
} = await useAsyncData(
  `get all gift products`,
  () =>
    $get(
      `/api/v1/product?limit=${perPage}&filter=isPublished||$eq||true;isGift||$eq||true&page=${page.value}&sort=publishedDate,DESC`
    ),
  { watch: [page], default: () => [], lazy: true }
);

const totalPages = computed(() => Math.ceil(totalProducts.value / perPage));

function changeMode(value) {
  mode.value = value;
}
</script>

<template>
  <div>
    <nuxt-layout name="default">
      <div class="container mb-6 lg:mb-10 mt-4 lg:mt-8 px-4 xl:px-0">
        <div
          class="flex flex-row pb-4 lg:pb-8 space-x-2 items-center justify-between"
        >
          <h3 class="font-lato font-semibold text-xl lg:text-4xl">
            Идеи для подарка
          </h3>
          <div class="flex-row space-x-4 hidden lg:flex">
            <p-icon-menu
              class="w-5 h-5 cursor-pointer"
              :color="mode === 'tile' ? '#3A405A' : '#BDC1D4'"
              @click="changeMode('tile')"
            />
            <p-icon-blocks
              class="w-5 h-5 cursor-pointer"
              :color="mode === 'simple' ? '#3A405A' : '#BDC1D4'"
              @click="changeMode('simple')"
            />
          </div>
        </div>

        <div v-if="products && products.length">
          <div
            class="grid gap-4 relative"
            :class="[
              mode === 'simple'
                ? 'grid-cols-1'
                : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
            ]"
          >
            <p-card v-for="product in products" :product="product" :mode="mode">
            </p-card>
            <p-product-loading v-if="isProductsLoading"></p-product-loading>
            <div
              class="el-loading-mask flex items-center justify-center"
              v-if="isProductsLoading"
            ></div>
          </div>
          <p-pagination-simple
            v-if="totalPages > 1"
            v-model="page"
            class="mt-8 mx-auto"
            position="center"
            :length="totalPages"
          ></p-pagination-simple>
        </div>
        <div
          style="box-shadow: 0px 4px 20px 0px #48507029"
          class="rounded-xl"
          v-else
        >
          <div class="grid gap-4 md:gap-6 p-4 md:p-16">
            <p
              class="font-semibold text-lg md:text-3xl text-center"
            >
              Товары отсутсвуют
            </p>
            <div
              class="flex flex-row items-center justify-center lg:!mt-5 space-x-3"
            >
              <p-button
                class="w-50 text-base h-9 lg:h-10"
                to="/catalog"
                type="secondary"
                >Перейти в каталог</p-button
              >
            </div>
          </div>
        </div>
      </div>
    </nuxt-layout>
  </div>
</template>
